import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';


@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit, OnChanges {

  @Input()
  label: string;

  @Input()
  icon: string;

  @Input()
  model: any;

  @Input()
  mode: string = 'normal';

  @Input()
  upper: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  

}



// WEBPACK FOOTER //
// ./src/app/core/component/core/input/input.component.ts